import { Component, OnInit, Inject } from '@angular/core';
import { LoadingService } from '../../../../shared/services/loading.service';
import { UserService } from '../../../../shared/services/user.service';
import { UpdateMeterComponent } from '../update-meter/update-meter.component';
import { ManageEquipmentService } from '../../manage-equipment.service';
import { NotificationsService } from 'angular2-notifications';
import { Subscription } from 'rxjs/Subscription';
import { ChangeMeterUnitModel } from '../../models/manage-equipment.model';
import { FormControl, Validators, FormGroup } from '@angular/forms';

import moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../../app/modules/rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-change-meter-unit',
  templateUrl: './change-meter-unit.component.html',
  styleUrls: ['./change-meter-unit.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
})
export class ChangeMeterUnitComponent implements OnInit {
  oldMeterSMUReading: number;
  newSMUReadingOnNewMeter: number;
  dateReplaced: Date = new Date();
  saving = false;
  private _equipmentId: number;
  private _subscriptions: Subscription[] = [];
  selectedCustomer: number;

  ChangeMeterDateControl = new FormControl(moment());



  changeMeterForm: FormGroup;
  oldsmuReadingInput: FormControl;
  newsmuReadingInput: FormControl;


  constructor( private _loading: LoadingService,
    private _user: UserService,
    public dialogRef: MatDialogRef<UpdateMeterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _equipment: ManageEquipmentService,
    private _notification: NotificationsService,
  ) { }

  ngOnInit() {
    this.selectedCustomer = this.data.customerId;
    this._equipmentId = this.data.equipmentId;
    this.createFormControls(this.data.smuPrechange);
    this.createForm();
  }



  changeMeterUnitClicked(): void {
    this._loading.startLoading();
    this.saving = true;
    const changeUnitModel = new ChangeMeterUnitModel();
    changeUnitModel.newSMUReadingOnNewMeter = this.newSMUReadingOnNewMeter;
    changeUnitModel.oldMeterSMUReading = this.oldMeterSMUReading;
    changeUnitModel.equipmentId = this._equipmentId;
    changeUnitModel.dateReplaced = this.dateReplaced;


    this._subscriptions.push(this._equipment.changeMeterUnit(changeUnitModel).subscribe(succeeded => {
        this._loading.finishedLoading();
        this.saving = false;
      if (succeeded.m_Item1) {
          this._notification.success('Meter Unit changed', 'This equipment meter has been successfully changed.');
          this.dialogRef.close(succeeded.m_Item1);
      } else {
        this._notification.error('Error', succeeded.m_Item2);
      }
    }));
  }

  createFormControls(preChangeMeterSMU: number) {
    this.oldsmuReadingInput = new FormControl('', [
      Validators.required,
      Validators.min(preChangeMeterSMU),
    ]);

    this.newsmuReadingInput  =  new FormControl('', [
      Validators.required,
    ]);
  }
  createForm() {
    this.changeMeterForm = new FormGroup({
      oldsmuReadingInput: this.oldsmuReadingInput,
      newsmuReadingInput : this.newsmuReadingInput,
    });
  }



  ngOnDestroy() {
    this._subscriptions.forEach(s => {
      if (!s.closed)
        s.unsubscribe();
    });
  }


  onNoClick(): void {
    this.dialogRef.close(false);
  }

}
